import { z } from "zod";
import { emailRegex } from "../../constants/regex";

export const zString = {
  zRequired: z.string().min(1, "Required"),
  zOptional: z.string().optional(),
};

export const zNumber = {
  zOptional: z.number().optional(),
  zRequired: z.number().min(1, "Required"),
};

export const zEmailSchema = z
  .string()
  .min(1, "Required")
  .max(254, "Email can have maximum 254 characters")
  .email("Invalid email")
  .regex(emailRegex, "Invalid email");

export const zCodeListSchema = z
  .object({
    code_list_value: z.string().min(1),
    code_list_value_code: z.string().min(1),
  })
  .nullable()
  .refine((value) => value !== null, {
    message: "Required",
  });
